<template>
  <div
    v-once
    class="calendar-hour d-flex align-items-center justify-content-center"
    :class="isMobile ? 'columna-fija' : ''"
  >
    <div class="font-weight-bold">
      {{ hour?.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailabilityCalendarHour',
  props: {
    hour: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/availability_calendar_colors.scss';
.calendar-hour {
  background-color: $calendar-accent;
  border: solid 1px #aab7b1;
}

.columna-fija {
  position: sticky;
  left: 0;
  min-width: 100px;
  box-sizing: content-box;
  margin: 0;
  padding: 0;
}
</style>
